var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOperationNotExists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale (-1, 1)",
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B868C",
    d: "M256,0C114.844,0,0,114.839,0,256s114.844,256,256,256s256-114.839,256-256S397.156,0,256,0z M356.196,239.301 c9.219,0,16.699,7.475,16.699,16.699s-7.48,16.699-16.699,16.699h-97.997l-29.688,66.797h127.685 c9.219,0,16.699,7.475,16.699,16.699c0,9.225-7.48,16.699-16.699,16.699H222.601c-2.949,0-5.844-0.228-8.738-0.443l-20.529,46.192 c-2.772,6.219-8.872,9.921-15.275,9.921c-2.261,0-4.567-0.468-6.773-1.446c-8.425-3.745-12.221-13.612-8.48-22.043l17.825-40.104 c-43.757-16.914-74.924-59.323-74.924-108.972c0-64.455,52.436-116.895,116.895-116.895h58.415l15.383-34.617 c3.751-8.42,13.579-12.225,22.049-8.474c8.425,3.745,12.221,13.612,8.48,22.043l-9.355,21.048h38.622 c9.219,0,16.699,7.475,16.699,16.699s-7.48,16.699-16.699,16.699H302.73l-29.688,66.797H356.196z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B868C",
    d: "M140.787,272.699c5.838,28.645,26.389,51.994,53.384,61.802l27.468-61.802H140.787z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7B868C",
    d: "M222.601,172.504c-40.324,0-74.057,28.731-81.814,66.797h95.697l29.686-66.797H222.601z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationNotExists);
export default __webpack_public_path__ + "static/media/operation_not_exists.c3d52b9fd89684c250427051d44d1af5.svg";
export { ForwardRef as ReactComponent };